import { getModel } from "core-web/state";

interface Value {
    [key: string]: any;
}

const SORT_ORDER = [
    // Sizes
    "XXS",
    "XS",
    "XS/S",
    "S",
    "S/M",
    "M",
    "M/L",
    "L",
    "L/XL",
    "XL",
    "XL/XXL",
    "XXL",
    "2XL",
    "XXL/3XL",
    "XXXL",
    "3XL",
    "XXXXL",
    "4XL",
    "5XL",
    "B146",
    "B148",
    "B150",
    "B152",
    "B154",
    "B156",
    "C30",
    "C32",
    "C34",
    "C36",
    "C38",
    "C40",
    "C42",
    "C42/142",
    "C42-142",
    "C44",
    "C44/144",
    "C46",
    "C46/146",
    "C48",
    "C48/148",
    "C50",
    "C50/150",
    'C50/35"',
    "C52",
    "C52/152",
    'C52/35"',
    "C54",
    "C54/154",
    'C54/35"',
    "C56",
    "C56/156",
    "C56-156",
    "C58",
    "C58/158",
    "C60",
    "C60/160",
    "C62",
    "C62/162",
    "C64",
    "C64/164",
    "C66",
    "C68",
    "C104",
    "C116",
    "C128",
    "C140",
    "C144",
    "C146",
    "C148",
    "C150",
    "C152",
    "C154",
    "C156",
    "C158",
    "C160",
    "C162",
    "C164",
    "D19",
    "D20",
    "D21",
    "D22",
    "D23",
    "D24",
    "D25",
    "D84",
    "D88",
    "D92",
    "D96",
    "D100",
    "D104",
    "D108",
    "D112",
    "D116",
    "D120",
    "D124",
    "D128",
    "D132",
    "D136",

    // Filter
    "SENDS_IN_0_DAYS",
    "SENDS_IN_1_DAYS",
    "SENDS_IN_2_DAYS",
    "SENDS_IN_3_DAYS",
    "SENDS_IN_5",
    "BOOKABLE",
];

export const sortArrayBasedOnAnotherArray = (array: any[], order: any[], key: string) => {
    array.sort((a, b) => {
        const A = a[key],
            B = b[key];

        if (order.indexOf(A) === -1 || order.indexOf(B) === -1) {
            return 1;
        }

        if (order.indexOf(A) > order.indexOf(B)) {
            return 1;
        }

        return -1;
    });
    return array;
};

export const sortItemsLastBasedOnAnotherArray = (array: any[], order: any[], key: string) => {
    array.sort((a, b) => {
        const A = a[key];
        const B = b[key];

        if (order.indexOf(A) < order.indexOf(B)) {
            return -1;
        }
        return 1;
    });

    return array;
};

export const sortObjectsByKey = (values: Value[], key = "label", sortNumeric = false) => {
    const locale = getModel("application").locale?.replace("_", "-");

    if (values.length <= 1) {
        return values;
    }

    return values.sort((a: Value, b: Value) => {
        if (!a[key] || !b[key]) {
            return 1;
        }

        if (sortNumeric) {
            if (parseInt(a[key], 10)) {
                return a[key].localeCompare(b[key], locale, { numeric: true, sensitivity: "accent" });
            }

            return 1;
        }

        return a[key].localeCompare(b[key], locale, { sensitivity: "accent" });
    });
};

export const sortValues = (values: any[], key = "label") => {
    let sortedValues = values;

    if (values.some((value) => SORT_ORDER.indexOf(value[key]) !== -1)) {
        sortedValues = sortObjectsByKey(values, key, true);
        sortedValues = sortArrayBasedOnAnotherArray(values, SORT_ORDER, key);
    } else if (values.every((value) => parseInt(value[key], 10))) {
        sortedValues = sortObjectsByKey(values, key, true);
    } else {
        sortedValues = sortObjectsByKey(values, key);
    }

    return sortedValues;
};
